<template>
  <!-- 报销审批流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">报销审批进度（ {{ details.Code }} ）</div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title title="报销信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">一级科目：</div>
            <div class="item-right">
              {{ details.FinancialEntry | filterSubject }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">二级科目：</div>
            <div class="item-right">
              {{ details.FinancialSubEntry | filterSubject }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">抬头企业：</div>
            <div class="item-right">
              {{ details.OwnerCompanyName }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">申请人：</div>
            <div class="item-right">
              {{ details.ApplyUserName }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">付款费用归属部门：</div>
            <div class="item-right">
              {{ details.CostDeptName }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">收款人：</div>
            <div class="item-right">
              {{ details.Payee }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">开户行：</div>
            <div class="item-right">
              {{ details.PayeeBankName }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">收款账号：</div>
            <div class="item-right">
              {{ details.PayeeBankAccount }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">报销总金额：</div>
            <div class="item-right">
              {{ $common.moneyFormat(details.TotalAmount) }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="item-left">报销备注：</div>
          <div class="item-right">
            {{ details.Remarks }}
          </div>
        </div>
      </div>
      <div v-for="(item, i) in details.Fees" :key="i">
        <div class="moduleTitle">
          <sub-title title="费用信息"></sub-title>
          <span class="serialNum">{{ i + 1 }}</span>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">费用类型：</div>
            <div class="item-right">
              {{ item.FeeCategory | filterSubject }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">费用事由：</div>
            <div class="item-right">
              {{ item.FeeMemo }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">费用金额：</div>
            <div class="item-right">
              {{ $common.moneyFormat(item.FeeAmount) }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">发生时间：</div>
            <div class="item-right">
              {{ $common.timesToTime(item.OccurDate) }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">发票：</div>
            <div class="item-right fileBox">
              <template
                v-if="
                  item.InvoiceAttachmentIds && item.InvoiceAttachmentIds != '[]'
                "
              >
                <div v-if="JSON.parse(item.InvoiceAttachmentIds).length > 1">
                  <el-link
                    type="primary"
                    @click="lookFeesList(JSON.parse(item.InvoiceAttachmentIds))"
                    >查看</el-link
                  >
                </div>
                <div v-else style="display: flex">
                  <el-image
                    class="preview-img"
                    :src="JSON.parse(item.InvoiceAttachmentIds)[0] | filterImg"
                  />
                  <el-link
                    type="primary"
                    class="link"
                    @click="
                      previewEvent(JSON.parse(item.InvoiceAttachmentIds)[0])
                    "
                    >{{ item.InvoiceAttachmentIds.split(':')[1] }}</el-link
                  >
                </div>
              </template>
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">备注：</div>
            <div class="item-right">
              {{ item.Remarks }}
            </div>
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart
        :details="details"
        :selTab="type"
        :TemplateID="TemplateID"
        v-if="JSON.stringify(details) != '{}'"
      >
        <div
          slot="user-defined"
          v-if="
            details.Status === 1 &&
            type == 2 &&
            details.CurrentNode.FullName === 'N6会计员'
          "
        >
          <div class="submitItem">
            <el-button
              type="danger"
              class="btn"
              @click="isShowRejectDialog = true"
              >驳 回</el-button
            >
            <el-button type="primary" class="btn" @click="accountantPass"
              >通 过</el-button
            >
          </div>
        </div>
      </flow-chart>
    </div>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="dialogImgVisible" center>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: flex-start;
          max-height: 58vh;
          overflow: auto;
          padding: 12px 0 24px 0;
        "
      >
        <img width="90%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
    <!-- 通过驳回弹窗 -->
    <reject-dialog
      :isShow.sync="isShowRejectDialog"
      tip="当前流程"
      @reject="confirmHandler"
    />
    <!-- 修改科目弹窗 -->
    <el-dialog
      title="通过"
      :visible.sync="subjectShow"
      center
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        :model="subjectForm"
        class="dialogForm"
        label-width="120px"
        ref="subjectForm"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              prop="costCompanyId"
              label="公司主体："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择公司主体"
                style="width: 240px"
                clearable
                filterable
                v-model="subjectForm.costCompanyId"
              >
                <el-option
                  v-for="item in InvoicingEntity"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="ownerCompanyName"
              label="抬头企业："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择抬头企业"
                style="width: 240px"
                clearable
                filterable
                v-model="subjectForm.ownerCompanyName"
              >
                <el-option
                  v-for="item in issuerList"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="financialEntry"
              label="一级科目："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择一级科目"
                style="width: 240px"
                clearable
                filterable
                @change="subjectForm.financialSubEntry = ''"
                v-model="subjectForm.financialEntry"
              >
                <el-option
                  v-for="item in stairArr"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="financialSubEntry"
              label="二级科目："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择二级科目"
                style="width: 240px"
                clearable
                filterable
                :disabled="!subjectForm.financialEntry"
                v-model="subjectForm.financialSubEntry"
              >
                <el-option
                  v-for="item in filterSecondary"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="actionRemark" label="备注：">
              <el-input
                type="textarea"
                :rows="2"
                style="width: 96%"
                placeholder="请输入备注"
                v-model="subjectForm.actionRemark"
              />
              <!-- style="width: 240px" -->
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-for="(items, index) in subjectForm.feeInfo"
            :key="index"
          >
            <el-form-item prop="Fees" :label="`费用事由${index + 1}：`">
              <div>
                <el-input
                  style="width: 240px"
                  v-model="items.FeeMemo"
                  placeholder="请输入费用事由"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="btnStyle">
              <el-button
                class="cancelWireless"
                size="medium"
                @click="subjectShow = false"
                >取 消</el-button
              >
              <el-button
                size="medium"
                type="primary"
                :loading="subjectLoad"
                @click="passWorkflow"
                >确 定</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 多张发票展示 -->
    <el-dialog
      title="发票列表"
      :visible.sync="dialogFeesValue"
      center
      width="600px"
    >
      <div style="max-height: 58vh; overflow: auto; padding: 12px 0 24px 0">
        <div
          v-for="(item, index) in InvoiceAttachmentIdsList"
          :key="index"
          style="
            display: flex;
            align-items: center;
            background-color: #fafafa;
            border-radius: 5px;
            padding: 8px 10px;
            margin: 8px 30px;
          "
        >
          <img
            :src="item | filterImg"
            alt=""
            style="width: 32px; height: 32px"
          />
          <div style="flex: 1; font-size: 14px; margin-left: 8px">
            {{ item.split(':')[1] }}
          </div>
          <div>
            <el-link
              type="primary"
              @click="previewEvent(item)"
              style="margin-right: 20px"
              >预览</el-link
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  WorkflowQuery,
  ApproveBidProjectTraceWorkflow,
  basic
} from '@/http/api'
import { fetchBatchSysDicList } from '../../../http/dictionary'
var that
export default {
  name: 'ChannelCommission',
  props: {
    ID: {
      // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    TemplateID: {
      // 流程ID
      type: Number,
      default: null
    }
  },
  data () {
    return {
      BASE_API: window.BASE_API,
      dialogImgVisible: false,
      previewImgUrl: '',
      details: {},
      isShowRejectDialog: false,
      subjectShow: false,
      InvoicingEntity: this.$InvoicingEntity,
      stairArr: this.$ReimburseSubject.filter(item => !item.ParentID),
      secondaryArr: this.$ReimburseSubject.filter(item => !!item.ParentID),
      filterSecondary: [],
      subjectForm: {
        workflowId: '',
        actionRemark: '', // 备注
        financialEntry: '', // 一级科目
        financialSubEntry: '', // 二级科目
        deviceType: 0, // 操作设备类型，0:PC端，1:移动端
        costCompany: '',
        costCompanyId: null, // 公司主体id
        feeInfo: [], // 费用事由(新增)
        ownerCompanyName: '' // 抬头企业名称
      },
      dialogFeesValue: false, // 发票弹框
      InvoiceAttachmentIdsList: [], // 发票列表
      issuerList: [], // 抬头企业数据
      ofdFileUrl:'',
    }
  },
  watch: {
    ID: {
      handler (val, oldVal) {
        this.getDetails()
        this.fetchBatch()
      },
      immediate: true
    },
    'subjectForm.financialEntry' (val) {
      if (val) {
        let find = this.stairArr.find(item => item.Name === val)
        let arr = this.secondaryArr.filter(item => item.ParentID === find.ID)
        this.filterSecondary = arr
      } else {
        this.filterSecondary = []
      }
    }
  },
  filters: {
    filterSubject (val) {
      const temp = that.$ReimburseSubject.find(item => item.Name == val)
      return (temp && temp.Title) || ''
    },
    /**
     * 过滤获取发票类型图片
     * @param {*} val 文件路径 例如：d920b586672d4a5192765cd1099fb8b4:avatar.jpg:558132
     * @returns {*} 返回匹配的文件图片路径
     */
    filterImg (val) {
      const fileNameParts = val.split(':')
      const fileName = fileNameParts[1]
      let url = ''
      switch (true) {
        case /\.(?:png|jpg|jpeg)$/i.test(fileName):
          url = '/static/picture/pciture-file-icon.png'
          break
        case /\.(?:doc|docx)$/i.test(fileName):
          url = '/static/picture/word-file-icon.png'
          break
        case /\.(?:xlsx|xls)$/i.test(fileName):
          url = '/static/picture/excel-file-icon.png'
          break
        case /\.(?:pdf)$/i.test(fileName):
          url = '/static/picture/pdf-file-icon.png'
          break
        case /\.(?:ppt|pps|pptx)$/i.test(fileName):
          url = '/static/picture/ppt-file-icon.png'
          break
        case /\.(?:zip|rar)$/i.test(fileName):
          url = '/static/picture/zip-file-icon.png'
          break
        default:
          break
      }
      return url
    }
  },
  created () {
    that = this
  },
  methods: {
    // 获取抬头企业数据
    fetchBatch () {
      fetchBatchSysDicList([
        {
          catalogName: 'OwnerCompanyName',
          sys: 'BasicData'
        }
      ]).then(res => {
        this.issuerList = res[0].Data
        // console.log('获取抬头企业数据', res)
      })
    },
    // 发票查看
    lookFeesList (InvoiceAttachmentIds) {
      this.dialogFeesValue = true
      this.InvoiceAttachmentIdsList = InvoiceAttachmentIds
    },
    accountantPass () {
      this.subjectForm.financialEntry = this.details.FinancialEntry
      this.subjectForm.financialSubEntry = this.details.FinancialSubEntry
      this.subjectForm.ownerCompanyName = this.details.OwnerCompanyName
      // 费用事由(回显)
      this.subjectForm.feeInfo = []
      this.details.Fees.forEach(item => {
        this.subjectForm.feeInfo.push({
          FeeId: +item.ID,
          FeeMemo: item.FeeMemo
        })
      })
      this.subjectShow = true
    },
    getDetails () {
      this.$emit('loading', true)
      WorkflowQuery(
        { workflowId: this.ID, templateId: this.TemplateID },
        'Get'
      ).then(res => {
        if (!!res && JSON.stringify(res) != '{}') {
          // console.log('dddd', res)
          this.details = res
        }
        this.$emit('loading', false)
      })
    },
    previewEvent (url) {
      // 预览图片
      if (/\.(?:jpg|jpeg|png)+(:\d*)*$/i.test(url)) {
        this.dialogImgVisible = true
        this.previewImgUrl = `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        // 预览pdf文件
      } else if (/\.(?:pdf)+(:\d*)*$/i.test(url)) {
        let pdf = encodeURIComponent(
          `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        )
        window.open(
          '/static/pdf/web/viewer.html?file=' + pdf + '&v=1.0.0',
          'PDF'
        )
      }else if (/\.(?:ofd)+(:\d*)*$/i.test(url)){
        this.ofdFileUrl = `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        // window.open(`https://ofd.xdocin.com/view?src=${this.ofdFileUrl}`)
        this.$common.previewWithKkFileView(this.ofdFileUrl)
      } else {
        this.$message.error('该文件类型无法预览')
      }
    },
    confirmHandler ({ success, complete, remark }) {
      ApproveBidProjectTraceWorkflow(
        'Refuse',
        this.details.ID,
        remark,
        'ReimbursementWorkflow'
      )
        .then(({ Code, Message }) => {
          if (Code === 1) {
            this.$emit('refresh')
            success()
          } else {
            this.$message.error(Message)
          }
        })
        .finally(_ => complete())
    },
    passWorkflow () {
      this.$refs.subjectForm.validate(valid => {
        if (valid) {
          this.subjectLoad = true
          let find = this.InvoicingEntity.find(
            item => item.ID === this.subjectForm.costCompanyId
          )
          this.subjectForm.costCompany = (find && find.Title) || ''
          this.subjectForm.workflowId = this.details.ID
          // console.log(' this.subjectForm', this.subjectForm)
          basic('ReimbursementWorkflow', 'Approve', this.subjectForm)
            .then(({ Code, Message }) => {
              if (Code === 1) {
                this.$emit('refresh')
                this.subjectShow = false
              }
              this.$message({
                type: Code === 1 ? 'success' : 'error',
                message: Message
              })
            })
            .finally(_ => {
              this.subjectLoad = false
            })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import './details.less';

// 修改科目弹框按钮样式
.btnStyle {
  text-align: center;
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.details-box-item {
  .details-box-item:nth-of-type(2) {
    .item-left {
      width: 126px;
    }
  }
  .details-box-item:nth-of-type(3) {
    .item-left {
      width: 126px;
    }
  }
}
.submitItem {
  display: flex;
  justify-content: center;

  .btn {
    width: 120px;

    & + .btn {
      margin-left: 32px;
    }
  }
}
.fileBox {
  .link {
    :deep(span) {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 240px;
    }
  }
}
.dialogForm {
  padding: 16px 0 12px 0;
  :deep(.el-button) {
    width: 92px;
  }
  :deep(.el-button + .el-button) {
    margin-left: 32px;
  }
}
</style>
